import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyFormat',
    standalone: false
})
export class CurrencyFormatPipe extends CurrencyPipe implements PipeTransform {
  transform(value: string, currencyCode?: string): any {
    if (isNaN(parseFloat(value))) {
      return value;
    }
    currencyCode = currencyCode || 'EUR';
    return super.transform(value, currencyCode, 'symbol', '1.2');
  }
}
